import React, { ReactNode } from 'react'
import { observer } from 'mobx-react'
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardContentDescription,
} from '../../../../../components/Card'
import RoomViewModel from './RoomViewModel'
import Button from '../../../../../components/Button'
import Avatar from '../../../../../components/Avatar'
import Tooltip from '../../../../../components/Tooltip'
import cx from 'classnames'
import styles from './RoomCard.sass'

interface Props {
  vm: RoomViewModel
  buttonGroup?: ReactNode
  titleContent?: ReactNode
  descriptionContent?: ReactNode
  progressBar?: ReactNode
}

export default observer(function RoomCard({
  vm,
  titleContent,
  descriptionContent,
  buttonGroup,
  progressBar,
}: Props) {
  if (!vm.activeRoom) {
    return <></>
  }
  return (
    <Card dataTest="current-task-new">
      <CardHeader>
        <CardTitle>{titleContent || 'Video Call'}</CardTitle>
      </CardHeader>
      <CardContent>
        {progressBar && (
          <>
            {progressBar}
            <br />
          </>
        )}
        <CardContentDescription>
          {descriptionContent || 'Join the video call by clicking below.'}
        </CardContentDescription>
      </CardContent>
      {vm.room.activeParticipants.length > 0 && (
        <CardContent>
          <RoomParticipants vm={vm} />
        </CardContent>
      )}
      <CardContent>
        <div className={styles.buttonGroup}>
          <Button
            type={'primary'}
            size={'wide-slim'}
            disabled={vm.join.pending || vm.isRoomClosed}
            loading={vm.join.pending}
            onClick={vm.join}
          >
            Join Call
          </Button>
          {buttonGroup}
        </div>
      </CardContent>
    </Card>
  )
})

interface RoomParticipantsProps {
  vm: RoomViewModel
}

/**
 Room Participants
 */
export const RoomParticipants = observer(function RoomParticipants({
  vm,
}: RoomParticipantsProps) {
  const participants = vm.participants
  return (
    <div className={styles.participants}>
      {participants.length > 4 ? (
        <span>{participants.length} participants</span>
      ) : (
        participants.map((p) => (
          <Tooltip
            content={`${p.user.displayName}`}
            placement={'bottom'}
            key={p.user.publicId}
          >
            <div className={cx(styles.participant)}>
              <Avatar size={24} subject={p.user} />
            </div>
          </Tooltip>
        ))
      )}
    </div>
  )
})
